export default {
  title_one: '🥳 {{offer}} angewendet',
  title_other: '🥳 {{count}} Angebote angewendet',
};
